import { useQuery } from '@tanstack/react-query';
import { getRecommendationService } from '../../../domains/recommendation';

/**
 * 처방 EDI 기반 팜인사이트 안내 (환자관리 AI 맞춤 추천 탭).
 * 응답 data: { situation_text, cautions, checks: { monitor, counsel }, supplements, purchase_checks }
 */
export const usePharmInsightGuide = (
  ediCodes: string[] | null | undefined,
  brn: string | null | undefined
) => {
  const edi = Array.from(new Set((ediCodes || []).filter(Boolean))).sort();
  return useQuery({
    queryKey: ['pharminsight-guide', edi, brn],
    enabled: edi.length > 0 && !!brn,
    queryFn: async () => {
      const res: any = await getRecommendationService().getPharmInsightGuide(edi, brn);
      return res?.data?.data ?? res?.data ?? null;
    },
  });
};
